:root {
  --sidebar-bg: #0d1b2a;
  --sidebar-bg-deeper: #091322;
  --sidebar-border: rgba(255, 255, 255, 0.06);
  --sidebar-accent: #00bfa5;
  --sidebar-accent-hover: #00d4b7;
  --sidebar-text-muted: #4a6478;
  --sidebar-text: #7a9ab5;
  --sidebar-text-bright: #c8dded;
  --topbar-bg: #ffffff;
  --topbar-border: #e8edf4;
  --topbar-height: 56px;
}

.brandIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: linear-gradient(135deg, var(--sidebar-accent), #0097a7);
  color: #fff;
  font-size: 14px;
  flex-shrink: 0;
}

.brandName {
  font-size: 13px;
  font-weight: 600;
  color: #d4e8f5;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1;
}

.userMenuTrigger {
  display: flex;
  align-items: center;
  gap: var(--ant-padding-xs);
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--ant-padding-xxs) var(--ant-padding-xs);
  border-radius: 6px;
  transition: background 0.15s ease;
}

.userMenuTrigger:hover {
  background: #f0f5fa;
}

.topbarAvatar {
  background: linear-gradient(135deg, #0d1b2a, #1a3a5c) !important;
  color: var(--sidebar-accent) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em !important;
  border: 1.5px solid rgba(0, 191, 165, 0.3) !important;
  flex-shrink: 0;
}

.contentWrapper {
  padding: 50px;
}

@media (max-width: 991px) {
  .contentWrapper {
    padding: var(--ant-padding-lg) var(--ant-padding-md);
  }
}

@media (max-width: 575px) {
  .contentWrapper {
    padding: var(--ant-padding-md) var(--ant-padding-sm);
  }
}

.topbarUsername {
  font-size: 13px;
  font-weight: 500;
  color: #2c3e50;
}

.footer {
  text-align: center;
  padding: var(--ant-padding-md) var(--ant-padding-lg);
}
